<template>
  <div class="container">
    <Breadcrumbs :items="breadcrumbs" />
    <section class="py-20 lg:py-32">
      <h1 class="text-3xl font-bold text-black-light mb-4">
        Dichiarazione di Accessibilità
      </h1>
      <h1 class="text-3xl lg:text-5xl font-bold"></h1>
      <ul class="max-w-[68rem]">
        <li v-for="(item, i) in links" :key="i">
          <a
            :href="item.value"
            target="_blank"
            class="flex gap-6 justify-between items-center text-lg font-bold text-blue py-3 border-b border-gray-lighter"
          >
            <span>{{ item.label }}</span>
            <SvgIcon
              name="angle-right-blue"
              class="ucrs-anchor__icon ucrs-anchor__icon--sm min-w-3"
            />
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import Breadcrumbs from '~/components/Breadcrumbs.vue'

export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Dichiarazione di Accessibilità',
        },
      ],
      links: [
        {
          value:
            '/assets/pdf/dichiarazione-di-accessibilita-www-unicreditres-it-2025.pdf',
          label: 'Dichiarazione di Accessibilità www.unicreditres.it',
        },
        {
          value:
            '/assets/pdf/dichiarazione-di-accessibilita-app-re-services-plus-agenti-2025.pdf',
          label: 'Dichiarazione di Accessibilità App RE Services PLUS Agenti',
        },
        {
          value:
            '/assets/pdf/dichiarazione-di-accessibilita-next-unicreditres-2025.pdf',
          label:
            'Dichiarazione di Accessibilità NEXT UniCredit RE Services Piattaforma Agenti',
        },
      ],
    }
  },
  head() {
    return {
      title: 'Dichiarazione di Accessibilità - UniCredit RE Services',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Dichiarazione di Accessibilità - UniCredit RE Services',
        },
      ],
    }
  },
}
</script>
